export const labelDashboardSnackbar =
    {
        "labelNetworkUnavailable": {
            "en": "Network connection is not available.",
            "es": "Red no disponible.",
            "fr": "Réseau indisponible.",
            "pt": "Rede indisponível.",
            "ru": "Сеть недоступна.",
            "zh": "Network unavailable."
        }
    };
